import { MsgService } from './../share/msg/msg.service';
import { SMILE9_ROLES, GUEST_RESERVATION_AUTH } from './../../environments/environment';
import { ROLES } from './../../environments/environment';
import { VERSION } from './../../environments/version';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { NavbarService } from './navbar.service';
import { UtilService } from '../share/util/util.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { NavbarIf } from './navbar-if';
import { SCAN_TYPE_MSG } from '../share/msg/scan-type-msg';
import { CONSTANT } from '../../constant/constant';
import { CONSTANT_URL } from '../../constant/constant-url';
declare var $;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  UG_OPTION = CONSTANT.UG_OPTION;
  SMILE9_USER_SETTINGS = CONSTANT.SMILE9_USER_SETTINGS;
  SCAN_TYPE_MSG = SCAN_TYPE_MSG;
  MAIN_USER_GUIDE = CONSTANT_URL.MAIN_USER_GUIDE;
  FSC_USER_GUIDE = CONSTANT_URL.FSC_USER_GUIDE;

  user = {
    dealer_code: '',
    dskbn: 0,
    ip: null,
    pg: null,
    sei_sum_kbn: 0,
    signin_id: '',
    tan_code: 0,
    tanto: null,
    tok_code: 0,
    user_email: '',
    user_id: 0,
    user_name: '',
    user_roles: '',
  };

  // 総務　メニュー開閉フラグ
  isOpenMenuGaRsv = false;
  isOpenMenuGaGa = false;
  isOpenMenuGaMaster = false;
  // 給食センター　メニュー開閉フラグ
  isOpenMenuFsc = false;
  // 個人予約　メニュー開閉フラグ
  isOpenMenuIndividual = false;
  // システム　メニュー開閉フラグ
  isOpenMenuSystem = false;

  phoneMenuOpen = false;
  accountMenuOpen = false;
  noticeMenuOpen = false;
  userName = '';
  ROLES = ROLES;
  SMILE9_ROLES = SMILE9_ROLES;
  GUEST_RESERVATION_AUTH = GUEST_RESERVATION_AUTH;
  SKS_WEBSITE = CONSTANT_URL.SKS_WEBSITE;
  prevEvent: Event;
  currentPath = '';

  subHttpClients = new Subscription();

  constructor(
    public authServ: AuthenticateService,
    public navbarServ: NavbarService,
    public utilServ: UtilService,
    private msgServ: MsgService,
    private router: Router,
  ) {
    this.user = JSON.parse(localStorage.getItem('user'));
    // 同じパスへ遷移しようとするとAngularはキャッシュを再利用する為、再利用を防止（通知キューから遷移するケースがある為）
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {

      }

      if (event instanceof NavigationEnd) {
        // ルーティングによるページ遷移完了後
        this.currentPath = event.url;
        this.closePhoneMenu();
      }
    });
  }

  ngOnInit() {
    this.currentPath = window.location.pathname;
    this.navbarServ.swingOnce = true;
    this.navbarServ.swingOnceSubject.next(this.navbarServ.swingOnce);
    this.navbarServ.currentVer = VERSION;
    // リロード時にもcheckToEnableAutoSignOut()メソッドが実行されるようにする
    if (this.authServ.smile9Role === '') {

    } else {
      this.authServ.checkToEnableAutoSignOut();
    }
    console.log('App version: ', this.navbarServ.currentVer);
  }

  ngOnDestroy() {
    // Http通信を一括キャンセル
    this.subHttpClients.unsubscribe();
  }

  /** icongramのURLを生成 */
  icongram(type :string, iconName: string, size = 20, hexColor = '666666'): string {
    return `https://icongr.am/${type}/${iconName}.svg?size=${size}&color=${hexColor}`;
  }

  isCurrentPath(bigTopicName: string): boolean {
    const pathArray: string[] = this.currentPath.split('/');
    if (pathArray[pathArray.length - 2] === bigTopicName) {
      return true;
    }
    return false;
  }

  acMenuOpen(event: Event): void {
    this.prevEvent = event;
    this.accountMenuOpen = true;
    event.stopPropagation();
  }

  acMenuClose(event: Event): void {
    // clickイベントよりmouseenterイベントが先に走る為、不必要なclickイベント処理は無効化する
    if (this.prevEvent.type === 'mouseenter') {
      this.prevEvent = event;
      return;
    }
    this.prevEvent = event;
    this.accountMenuOpen = false;
    event.stopPropagation();
  }

  /** 通常のサインアウト処理を実行した */
  public normalSignOut(): void {
    this.navbarServ.normalSignOut();
  }

  /** いただきます端末で個人予約画面のサインアウト処理を実行した */
  public itadakimasuSignOut(): void {
    this.navbarServ.itadakimasuSignOut();
  }

  /** ドロップダウンメニューのON/OFF切り替え */
  public dropdownSwitch(prop: any): void {
    this[prop] === true ? this[prop] = false : this[prop] = true;
  }
  /** スマホ用メニューON/OFF切り替え */
  public phoneMenuSwitch(): void {
    if (this.phoneMenuOpen) {
      this.phoneMenuOpen = false;
    } else {
      this.phoneMenuOpen = true;
      this.noticeMenuOpen = false;
    }
  }
  public closePhoneMenu(): void {
    this.phoneMenuOpen = false;
  }

  linkUrl(url: string) {
    const a = document.createElement('a');
    a.setAttribute('target', 'newtab');
    a.setAttribute('href', url);
    document.body.appendChild(a).click();
  }

  async reloadAsync() {
    // ローディング画像表示
    this.authServ.isWaitAuthenticating = true;
    await this.navbarServ.readNoticeOnDisplayAsync();
    // 引数にtrue指定でハードリロード実行
    location.reload();
  }

  public openRegisterFavPage(): void {
    window.open(`${location.protocol}//${location.host}/register-fav`, '_blank');
  }

  public openMainUserGuide(): void {
    window.open(this.MAIN_USER_GUIDE, '_blank');
  }

  public openFscUserGuide(): void {
    window.open(this.FSC_USER_GUIDE, '_blank');
  }
}
